import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import WalletForm from "./WalletForm";

const WalletAdd = () => {
    return (
        <Fragment>
            <WalletForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default WalletAdd;